import React, { useState } from 'react';

// ANTD
import { Modal } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
// IMAGE
import tourstart_transfer from 'static/img/downloadGps/tourstart_transfer.png';
import cancel from 'static/img/cancel.png';

import { FormattedMessage } from 'react-intl';

import withTranslations from 'app/components/HOGs/withTranslations';
import { onDownloadDataClick } from '../downloadGpsTT.services';

const Settings = ({ showLegal, tr }) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <SettingOutlined onClick={() => setVisible(true)} />
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        mask
        footer={false}
        wrapClassName="gpsQuestionModal"
        width="50%"
        style={{ paddingBottom: 0, borderRadius: 4, minHeight: '50%' }}
        centered
        closeIcon={<img src={cancel} alt="cancel" />}
      >
        <div className="header">
          <img
            src={tourstart_transfer}
            alt="tourstart_transfer"
            style={{
              margin: 0,
              marginRight: 5,
              height: 'initial',
              width: 'initial',
            }}
          />
          {tr.Settings}
        </div>
        <div className="mainContent">
          <p style={{ padding: '0px 10px', marginBottom: 0, fontSize: 13 }}>
            <strong>
              <FormattedMessage id="About" defaultMessage="About" />
            </strong>
          </p>
          <ul style={{ fontSize: 12, listStyleType: 'none' }}>
            <li>© Tourstart ApS 2018 All Rights Reserved</li>
            <li>Tourstart ApS</li>
            <li>Løvet Møllevej 6</li>
            <li>DK-8740 Brædstrup</li>
            <li>
              <a
                href="mailto:info@tourstart.org"
                style={{ textDecoration: 'underline' }}
              >
                info@tourstart.org
              </a>
            </li>
            <li>+45 42 550 660</li>
            <br />
            <li>
              <a
                style={{ textDecoration: 'underline' }}
                onClick={showLegal}
                aria-hidden
              >
                <FormattedMessage
                  id="Legal issues"
                  defaultMessage="Legal issues"
                />
              </a>
            </li>
            <br />
            <li>
              <a
                style={{ textDecoration: 'underline' }}
                onClick={() => onDownloadDataClick('TourstartTransfer')}
                aria-hidden
              >
                <FormattedMessage
                  id="Download Tourstart Transfer"
                  defaultMessage="Download Tourstart Transfer"
                />
              </a>
            </li>
          </ul>
        </div>
      </Modal>
    </>
  );
};

export default withTranslations(Settings);
